import { Link } from "@inertiajs/react"
import croatiaSilhouetteUrl from "@/assets/croatia.svg?url"
import { cn } from "@/lib/utils"

export function PublicLogo({
  href = "/en",
  compact = false,
}: {
  href?: string
  compact?: boolean
}) {
  return (
    <Link
      href={href}
      className="inline-flex items-center gap-2 text-ink-display no-underline"
      aria-label="Xplore Croatia home"
    >
      <span
        className={cn(
          "flex shrink-0 items-center justify-center rounded-[0.625rem] bg-accent-hover",
          compact ? "h-8 w-8" : "h-9 w-9",
        )}
      >
        <span
          className={cn("block bg-surface-tinted", compact ? "h-6 w-6" : "h-7 w-7")}
          style={{
            WebkitMask: `url(${croatiaSilhouetteUrl}) center / contain no-repeat`,
            mask: `url(${croatiaSilhouetteUrl}) center / contain no-repeat`,
          }}
          aria-hidden
        />
      </span>
      <span className={cn("font-display font-semibold leading-none", compact ? "text-sm" : "text-[0.95rem]")}>
        <span className="block">Xplore</span>
        <span className="block text-accent">Croatia</span>
      </span>
    </Link>
  )
}
